import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import DealTicker from "@/components/DealTicker";
import PartnerBar from "@/components/StatsStrip";
import Comparison from "@/components/Comparison";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import Features from "@/components/WhyUs";
import Testimonials from "@/components/Testimonial";
import ApplicantTestimonials from "@/components/ApplicantTestimonials";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/CTA";
import Footer from "@/components/Footer";
import useSeo from "@/hooks/useSeo";

export default function Landing() {
  useSeo({
    title: "SwiftCash — UK Business Finance from £5k to £500M",
    description: "Fast UK business finance from £5,000 to £500,000,000. Whole-of-market panel, indicative terms in hours, no impact on your business credit file.",
    path: "/",
  });
  return (
    <div className="bg-white text-navy min-h-screen">
      <Navbar />
      <Hero />
      <DealTicker />
      <PartnerBar />
      <Comparison />
      <Features />
      <HowItWorks />
      <Pricing />
      <ApplicantTestimonials />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
